exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".course-app .introduction-section .title {\n  font-size: 18px;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n", ""]);
